// Formateo centralizado de fechas del CRM en zona horaria Europe/Madrid.
// Los timestamps se guardan en UTC (ISO con tz) y SIEMPRE se muestran al
// usuario convertidos a Europe/Madrid, respetando CET/CEST automáticamente.
const MADRID = "Europe/Madrid";

// UTC ISO → "DD/MM/YYYY HH:mm" (Europe/Madrid). Vacío → "—".
export function formatMadridDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return d
    .toLocaleString("es-ES", {
      timeZone: MADRID,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(",", "");
}

// UTC ISO → "DD/MM/YYYY" (Europe/Madrid). Vacío → "—".
export function formatMadridDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("es-ES", {
    timeZone: MADRID,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
